export default __webpack_public_path__ + "static/ice-attacks-4ba961a2dc574bffeeead4c4605e2367.png";